import { UseFormReturn } from 'react-hook-form';
import { useAppSelector } from '@/store/hooks';
import { PAYIN_AUDIENCE_TYPES, PAYIN_SCHOOL_SEGMENTS } from '@/constants/constants';

const { PRIMARY } = PAYIN_SCHOOL_SEGMENTS;

export const useUserDetailsAutofill = ({ setValue, trigger }: UseFormReturn, isNonProduction: boolean) => {
  const audience = useAppSelector(state => state.payin.audience);

  return () => {
    if (!isNonProduction) {
      return;
    }

    const email = import.meta.env.VITE_DEV_FILL_EMAIL ?? 'autofill@test.com';

    const autofillValues: Record<string, string> = {
      firstName: import.meta.env.VITE_DEV_FILL_FIRSTNAME ?? 'Autofill',
      lastName: import.meta.env.VITE_DEV_FILL_LASTNAME ?? 'Autofill',
      email,
      confirmEmail: email,
      address1: 'Comic Relief',
      address2: '10 Whitechapel High Street',
      town: 'London',
      postcode: 'E1 8QS',
    };

    // The 'organisation name' field can have
    //  different IDs depending on the audience
    if (audience === PAYIN_AUDIENCE_TYPES.WORK) {
      autofillValues.organisationName = 'Eng Team';
    } else if (audience === PAYIN_AUDIENCE_TYPES.SCHOOL) {
      autofillValues.establishmentName = 'Eng Team';
      autofillValues.establishmentType = PRIMARY;
    }

    Object.entries(autofillValues).forEach(([field, value]) => {
      setValue(field, value);
    });

    // Because we can't use onBlur with autofilling
    void trigger();
  };
};
